import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { DESVINCUAL_PACIENTE_SAP, UPDATE_DELEGACION_PACIENTE, UPDATE_FECHA_NACIMIENTO_PACIENTE, UPDATE_NUMERO_DOCUMENTO_PACIENTE } from "../../../../data/graphQL/mutations/SoporteHC/paciente";
import { useMutationHandler } from "../../hooks/useMutationHandler";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client/react";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionArray } from "../../../../adapters/delegacionAdapter";

const storageIdUsuario = sessionStorage.getItem('idUsuario');

export default function CambiarDelegacionForm() {
    const inputFields = [
        {
            name: 'idEvaluacion',
            type: 'int',
            displayName: 'Contrato',
            size: 2,
            required: false,
            placeholder: 'Ingrese ID Contrato'
        },
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC Paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
        {
            name: 'idDelegacion',
            type: 'select',
            displayName: 'Delegación',
            size: 2,
            required: true,
            placeholder: 'Seleccionar delegación'
        },
    ];

    const [delegaciones, setDelegaciones] = useState([]);

    const { data: dataDelegaciones } = useQuery(GET_DELEGACIONES_BY_USUARIO, {
        variables: { idUsuario: JSON.parse(storageIdUsuario, 10) }
    });

    useEffect(() => {
        if (!dataDelegaciones) return;
        setDelegaciones(adaptDelegacionArray(dataDelegaciones, false));
    }, [dataDelegaciones]);

    const { values, handleChange, handleSubmit, loading } =
        useMutationHandler({
            initialValues: {
                idEvaluacion: null,
                idPaciente: '',
                idDelegacion: ''
            },
            mutation: UPDATE_DELEGACION_PACIENTE,
            onSuccess: (data) => {
                if (data.updateDelegacionPacienteContrato.error) {
                    toast.error(data.updateDelegacionPacienteContrato.error);
                }

                if (data.updateDelegacionPacienteContrato.success)
                    toast.success('La delegación se actualizó correctamente.');
            },
            inputFields
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => {
                    const inputWithOptions = input.name === 'idDelegacion'
                        ? { ...input, options: delegaciones }
                        : input;

                    return (
                        <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                            <RenderInputByTypeMobile
                                input={inputWithOptions}
                                value={values[input.name]}
                                handleChange={handleChange}
                            />
                        </Grid>
                    );
                })}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
